const helloAndGoodbye = {
  roleplayId: "nualang.hello-goodbye.0.0.1",
  roleplayName: "Hola y adiós",
  description: "Aprende a decir hola y adiós",
  difficulty: "ALL",
  learnLang: "spanish",
  picture: "",
  actor1: {
    name: "Lupe",
    voice: "Lupe",
    picture:
      "https://images.nualang.com/eyJidWNrZXQiOiJudWFsYW5nLWltYWdlcy1wcm9kIiwia2V5IjoiYXZhdGFycy8wLW51YWxhLTAwMi5wbmcifQ==",
  },
  actor2: {
    name: "Alonso",
    voice: "Alonso",
    picture:
      "https://images.nualang.com/eyJidWNrZXQiOiJudWFsYW5nLWltYWdlcy1wcm9kIiwia2V5IjoiYXZhdGFycy8wLW51YWxhLTAwNC5wbmcifQ==",
  },
  script: [
    { text: "Hola. ¿Como estas?", actor: 1 },
    { text: "Estoy bien. Gracias por preguntar. ¿Cómo estás?", actor: 2 },
    { text: "No me puedo quejar, la vida me está tratando bien.", actor: 1 },
    { text: "Eso es bueno escuchar.", actor: 2 },
    {
      text: "Es bueno verte de nuevo, tengo que ir a la cita con mi médico.",
      actor: 1,
    },
    { text: "Que bueno verte.", actor: 2 },
    { text: "Adiós", actor: 1 },
  ],
};

export default helloAndGoodbye;
